import React from 'react';
import { Row } from 'antd';
import { useAppState } from 'services/providers/AppState';

const TermsOfUse = () => {
  const { customerPortalConfig, locale } = useAppState();

  const termsOfUse = customerPortalConfig?.termsOfUse?.[locale?.toUpperCase()];
  return (
    <Row>
      <div
        style={{ width: '100%' }}
        dangerouslySetInnerHTML={{
          __html: termsOfUse,
        }}
      />
    </Row>
  );
};

export default TermsOfUse;
